import type * as Blockly from 'blockly/core';
import { expr, resolveBoard } from '@/(routers)/boards/editor/block/generators/arduino/_gen';
import { markAngleUsed } from '@/(routers)/boards/editor/block/generators/arduino/blocks/sensing/helper/accelerometer_helper';

type AngleType = 'X' | 'Y' | 'Z';

export function register(gen: any): void {
    gen.forBlock['accelerometer_angle'] = function (block: Blockly.Block): [string, number] {
        const position = block.getFieldValue('POSITION');
        const type = block.getFieldValue('TYPE') as AngleType;
        const board = resolveBoard(block);

        markAngleUsed(position, type);

        if (board === 'blue') {
            const varMap: Record<AngleType, string> = {
                X: 'rel_angleX',
                Y: 'rel_angleY',
                Z: 'rel_angleZ',
            };
            return expr(varMap[type]);
        } else {
            const fnMap: Record<AngleType, string> = {
                X: 'relativeAngleX()',
                Y: 'relativeAngleY()',
                Z: 'relativeAngleZ()',
            };
            return expr(fnMap[type]);
        }
    };
}
